export default function (date: Date): string {
  return useFormatDate('graphqlFilter', date.toString())
}
